import React from "react"
import { Container, Wrapper, SeasonAndDate, IconWithText, Episode, Title, Date, Subtitle, Text, Content, Thumbnail, Image } from "./styles/lastseason"
import { Icon } from "../../components"

export default function LastSeason({ children, path, ...rest }) {
  return (
    <Container {...rest} path={path}>
      <Wrapper>{children}</Wrapper>
    </Container>
  )
}
LastSeason.Content = function heroContent({ children, ...rest }) {
  return <Content {...rest}>{children}</Content>
}

LastSeason.Thumbnail = function heroThumbnail({ src, ...rest }) {
  return <Thumbnail {...rest}>{src ? <Image src={`https://image.tmdb.org/t/p/w500${src}`} title="Movie Thumb" /> : ""}</Thumbnail>
}
LastSeason.Title = function heroTitle({ children, date, ...rest }) {
  return (
    <Title {...rest}>
      {children} <Date>({date})</Date>
    </Title>
  )
}

LastSeason.Subtitle = function heroSubtitle({ children, ...rest }) {
  return <Subtitle {...rest}>{children}</Subtitle>
}

LastSeason.Text = function heroText({ children, ...rest }) {
  return <Text {...rest}>{children}</Text>
}

LastSeason.Episode = function heroEpisode({ children, ...rest }) {
  return <Episode {...rest}>{children}</Episode>
}

LastSeason.SeasonAndDate = function heroSeasonAndDate({ children, ...rest }) {
  return <SeasonAndDate {...rest}>{children}</SeasonAndDate>
}

LastSeason.IconWithText = function heroIconWithText({ icon, text, ...rest }) {
  return (
    <IconWithText {...rest}>
      <Icon name={icon} />
      <p>{text}</p>
    </IconWithText>
  )
}
